import React from "react";
import dayjs, { Dayjs } from "dayjs";

export const DCalender: React.FC = () => {
    // Generate last 12 months
    const months: Dayjs[] = Array.from({ length: 12 }, (_, i) =>
        dayjs().subtract(i, "month")
    ).reverse();

    // Function to generate calendar days for a month
    const generateCalendar = (date: Dayjs): (number | null)[] => {
        const startOfMonth = date.startOf("month");
        const endOfMonth = date.endOf("month");
        const days: (number | null)[] = [];
        const startDay = startOfMonth.day();

        // Add empty slots for days before the first day of the month
        for (let i = 0; i < startDay; i++) {
            days.push(null);
        }

        // Add actual days of the month
        for (let day = 1; day <= endOfMonth.date(); day++) {
            days.push(day);
        }

        return days;
    };

    return (
        <div style={{ fontFamily: "'Inter', sans-serif", padding: "16px", width: 'fit-content' }}>
            <h2 style={{ fontSize: "1.25rem", fontWeight: "bold", marginBottom: "16px" }}>
                Last 12 Months Calendar
            </h2>
            <div style={{ display: "grid", gridTemplateColumns: "repeat(4, 1fr)", gap: "16px" }}>
                {months.map((month, index) => (
                    <div key={index} style={{ border: "1px solid #ccc", padding: "8px", textAlign: "center" }}>
                        <h3 style={{ fontWeight: "600", marginBottom: "8px" }}>
                            {month.format("MMMM YYYY")}
                        </h3>
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "4px", fontWeight: "bold", fontSize: "0.875rem" }}>
                            {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((day) => (
                                <div key={day}>{day}</div>
                            ))}
                        </div>
                        <div style={{ display: "grid", gridTemplateColumns: "repeat(7, 1fr)", gap: "4px" }}>
                            {generateCalendar(month).map((day, i) => (
                                <div key={i} style={{ border: "1px solid #ddd", padding: "8px", height: "32px", display: "flex", alignItems: "center", justifyContent: "center" }}>
                                    {day || ""}
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};


